<template>
  <div>
  <v-text-field
    v-if="!editable"
    :label="item.label || undefined"
    :placeholder="item.placeholder || undefined"
    :mask="item.mask || undefined"
    :rules="item.rules || []"
    v-model="itemValue"
    :class="item.editable ? 'text-field' : ''"
    :counter="item.counter || undefined"
    :required="item.required || false"
    :dark="item.dark || false"
    :hint="item.hint || undefined"
    :autofocus="item.autofocus || false"
    :multi-line="item.multi_line || false"
    :disabled="item.disabled || false"
    :autocomplete="item.autocomplete || 'name'"
    :prepend-icon="item.prepend_icon || undefined"
    :append-icon-cb="() => {visibility = !visibility}"
    :append-icon="item.hidden_append_icon === true ? undefined : (item.append_icon || item.type === 'password' ? (visibility ? 'visibility' : 'visibility_off') : undefined)"
    :color="item.color || undefined"
    :type="item.type === 'password' ? (visibility ? 'text' : 'password') : 'text'"
    v-on:keyup.enter="focusNextField($event)"
    v-on:blur="onBlur($event)"
  ></v-text-field>
  <div v-if="editable" class="input-group input-group--dirty input-group--text-field primary--text" :class="(item.required && !itemValue) ? 'input-group--required' : ''">
    <label v-if="item.hidden_label === true ? false : true" class="editable">{{ item.label }}</label>
      <v-edit-dialog
        lazy
        class="edit-dialog"
        v-if="!item.disabled"
      >
        <v-tooltip v-if="item.tooltip || false" open-delay="500" right>
          <span :class="item.value_class || ''" slot="activator">{{ (item.prepend_text || '') + itemValue + (item.append_text || '') }}</span>
          <span>{{ item.tooltip }}</span>
        </v-tooltip>
        <span v-else>
          {{ (item.prepend_text || '') + itemValue + (item.append_text || '') }}
        </span>
        <div slot="input" class="mt-3 title">{{ item.label }}</div>
        <v-text-field
          slot="input"
          :label="item.label || undefined"
          :placeholder="item.placeholder || undefined"
          :mask="item.mask || undefined"
          :rules="item.rules || []"
          v-model="itemValue"
          single-line
          :counter="item.counter || undefined"
          :required="item.required || false"
          :dark="item.dark || false"
          :autofocus="true"
          :multi-line="item.multi_line || false"
          :hint="item.hint || undefined"
          :disabled="item.disabled || false"
          :autocomplete="item.autocomplete || 'name'"
          :prepend-icon="item.prepend_icon || undefined"
          :append-icon-cb="() => {visibility = !visibility}"
          :append-icon="item.hidden_append_icon === true ? undefined : (item.append_icon || item.type === 'password' ? (visibility ? 'visibility' : 'visibility_off') : undefined)"
          :color="item.color || undefined"
          :type="item.type === 'password' ? (visibility ? 'text' : 'password') : 'text'"
          v-on:keyup.enter="focusNextField($event)"
          v-on:blur="onBlur($event)"
        ></v-text-field>
      </v-edit-dialog>
      <span :class="item.value_class || ''" class="edit-dialog" v-else>
        {{ (item.prepend_text || '') + itemValue + (item.append_text || '') }}
      </span>
    </div>
  </div>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyTextField',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: () => ({
    itemValue: '',
    visibility: false,
    editable: false,
    oldVal: ''
  }),

  created () {
    this.itemValue = this.value || this.itemValue
    this.oldVal = this.itemValue
    this.isEditable()
  },

  watch: {
    itemValue: {
      handler: function (val, oldVal) {
        this.oldVal = this.oldVal !== this.itemValue ? this.itemValue : this.oldVal
        this.$emit('on-keyup', val, this.oldVal, this.item, this.isValid())
      },
      deep: true
    },
    value: {
      handler: function (val, oldVal) {
        this.itemValue = val
        this.$emit('on-change', val, oldVal, this.item, this.isValid())
        this.oldVal = this.oldVal !== this.itemValue ? this.itemValue : this.oldVal
        this.isEditable()
      },
      deep: true
    }
  },

  methods: {
    focusNextField: function (event) {
      this.isEditable()
      if (this.editable && this.item.focusNextOnEnter) {
        if (event.target.form && event.target.form[this.item.index + 1]) {
          event.target.form[this.item.index + 1].focus()
        }
      }
    },
    isValid: function () {
      let isValid = true
      if (this.item.rules) {
        this.item.rules.forEach(rule => {
          if (rule(this.itemValue) !== true) {
            isValid = false
          }
        })
      }
      this.item.valid = isValid
      return isValid
    },
    isEditable: function () {
      this.editable = (this.item.editable || false) && this.isValid() && this.itemValue !== ''
    },
    onBlur: function (event) {
      this.$emit('on-blur', this.itemValue, this.val, this.item, this.isValid())
      this.isEditable()
    }
  }
}
</script>

<style lang="sass">


.edit-dialog
  display: block !important
  text-align: left
  height: 31px
  margin: 0
  font-size: 16px
  padding-bottom: 8px
  margin-top: 3px
  color: rgba(0,0,0,0.87)

.text-field
  margin-bottom: -22px

.editable:after
    content: '' !important
</style>


// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-text-field.vue